import "./FileOverlay.less";

interface ImageOverlayProps {
   file: string;
   onClose: () => void;
}

export const FileOverlay = ({ file, onClose }: ImageOverlayProps) => {
   const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation();
   };

   const isVideo = /\.(mp4|webm|ogg)$/i.test(file);

   return (
      <div className="file-overlay" onClick={onClose}>
         {isVideo ? (
            <video src={file} controls className="file-overlay__video" onClick={handleClick} />
         ) : (
            <img
               src={file}
               alt="Full image"
               className="file-overlay__image"
               onClick={handleClick}
            />
         )}
      </div>
   );
};
